// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getDealerRecommendation} from '../../shared/repositories/index';

export const getDealerRecommendations = (page, size, paginationType) =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const dealerRecommendations = await getDealerRecommendation(page, size);

            dispatch({
                data: dealerRecommendations,
                paginationType,
                type: actions.GET_DEALER_RECOMMENDATIONS
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const updateDealerRecommendationCheckBox = (dealerRecommendation, isSelected) =>
    dispatch => {

        dispatch({
            dealerRecommendation,
            isSelected,
            type: actions.UPDATE_SELECTED_DEALER_RECOMMENDATIONS
        });

    };

export const toggleSelectAll = dealerRecommendation =>
    dispatch => {

        dispatch({
            dealerRecommendation: dealerRecommendation.map(dealer => dealer.id),
            type: actions.UPDATE_SELECTED_ALL_DEALER_RECOMMENDATIONS
        });

    };

export const resetSelectedDealerRecommendations = () =>
    dispatch => {

        dispatch({
            type: actions.RESET_SELECTED_DEALER_RECOMMENDATIONS

        });

    };

export const updateRecommendationComment = recommendation =>
    dispatch => dispatch({
        data: recommendation,
        type: actions.UPDATE_RECOMMENDATION_COMMENT_SUCCESS
    });




// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/action-creators/dealer-recommendation.js